import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Phone } from "lucide-react";
import { Reveal } from "../Reveal";
import { FAQS, PHONE, PHONE_HREF } from "../../lib/site";

export const Faq = ({ items = FAQS }) => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-white py-24 md:py-32" data-testid="faq">
      <div className="max-w-4xl mx-auto px-6 md:px-8">
        <Reveal>
          <div className="text-center">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#d90429]">Questions, answered</span>
            <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0b192c] tracking-tight">
              Frequently asked questions
            </h2>
          </div>
        </Reveal>

        <div className="mt-14">
          {items.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-6 text-left group"
                  data-testid={`faq-trigger-${i}`}
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span className="font-display font-semibold text-lg md:text-xl text-[#0b192c] group-hover:text-[#d90429] transition-colors">{f.q}</span>
                  <span className={`shrink-0 w-8 h-8 rounded-full border border-slate-300 flex items-center justify-center transition-transform duration-300 ${isOpen ? "rotate-45 bg-[#d90429] border-[#d90429]" : ""}`}>
                    <Plus className={`w-4 h-4 ${isOpen ? "text-white" : "text-[#0b192c]"}`} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p id={`faq-answer-${i}`} className="pb-6 text-slate-600 leading-relaxed max-w-3xl">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600">Still have questions? Our specialists are ready to help.</p>
          <a href={PHONE_HREF} className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#0b192c] text-white px-6 py-3 font-semibold hover:bg-[#1a2a40] transition-colors" data-testid="faq-call-btn">
            <Phone className="w-4 h-4" /> Call {PHONE}
          </a>
        </div>
      </div>
    </section>
  );
};
